import { AutoCompleteLocation } from "./useMapAutoComplete";
import React from "react";
import styled from "styled-components";
type SuggestionListItemProps = {
  item: AutoCompleteLocation;
  key: string;
  onClick: (item: AutoCompleteLocation) => void;
};
function SuggestionListItem(props: SuggestionListItemProps) {
  const {
    key,
    item,
    onClick
  } = props;
  const selectionMade = () => {
    onClick(item);
  };
  return <ListItem key={key} data-sentry-element="ListItem" data-sentry-component="SuggestionListItem" data-sentry-source-file="SuggestionListItem.tsx">
      <ListButton onClick={selectionMade} data-sentry-element="ListButton" data-sentry-source-file="SuggestionListItem.tsx">
        {item.displayLines.join(", ")}
      </ListButton>
    </ListItem>;
}
const ListItem = styled.li`
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  order-style: solid;
  width: 100%;
  min-height: 2rem;
  display: list-item;
  text-align: -webkit-match-parent;
  unicode-bidi: isolate;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  &:first-child {
    border-botton: 0;
  }
`;
const ListButton = styled.button`
  text-align: left;
  cursor: pointer;
  -webkit-appearance: button;
  background-color: transparent;
  background-image: none;
  text-transform: none;
  min-height: inherit;
  width: 100%;
  border: 0;
`;
export default SuggestionListItem;